<template>
  <div>
    <label><b>Cpt Codes</b></label>
    <DxTagBox
      :value="value"
      placeholder="Select cpt codes..."
      :show-selection-controls="true"
      search-expr="displayName"
      searchMode="contains"
      display-expr="displayName"
      :data-source="dataSource"
      :maxDisplayTags="5"
      :showDropDownButton="true"
      :search-enabled="true"
      :hideSelectedItems="true"
      @value-changed="onValueChanged"
      :dropdownOptions="dropdownOptions"
    >
    </DxTagBox>
  </div>
</template>

<script>
import DropDownApis from "../../../services/dropdown.js";
import DxTagBox from "devextreme-vue/tag-box";
import { mapState } from "vuex";

export default {
  name: "CPT",
  inheritAttrs: false,
  components: {
    DxTagBox
  },
  props: {
    noPrimary: {
      type: Boolean,
      default: false
    },
    setPrimary: {
      type: Function
    },
    value: {
      required: true
    }
  },
  data: () => ({
    dropdownOptions: {
      position: "bottom"
    }
  }),
  methods: {
    onValueChanged(e) {
      this.cptCodes = e.value;
    }
  },
  computed: {
    ...mapState(["currentUser", "currentLab"]),
    cptCodes: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      }
    },
    dataSource() {
      return DropDownApis.searchCptCodes;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__tag {
  background-color: $neutral;
  color: #35495e;
}
</style>
